<template>
    <section class="headGrp headGrpSS">
        <div class="digBanner"><a href="https://jointex.meclib.jp/library/books/ichioshi_31/book/"
        target="_blank"><img class="pc" :src="img_common_path + digital_banner" alt="カタログデジカタバナー"></a></div>
        <div class="wrap01 centerHH">
            <h2 class="header_title">
                <img class="pc" :src="img_common_path + header_title" alt="オススメの家具を厳選！イチオシ家具">
                <img class="sp" :src="img_common_path + header_title_sp" alt="オススメの家具を厳選！イチオシ家具">
            </h2>
        </div>


    </section>
</template>

<script>
export default {
    setup() {
        const img_common_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/common/"
        const Home_Top_Img = "Home_Top_img.svg"
        const header_title = "header_title.png"
        const header_title_sp = "header_title_sp.png"
        const digital_banner = "digital_banner_vol31.png"

        // スクロールするやつ
        async function toDelivery() {
            const element = document.getElementById('toDelivery')
            const position = element.getBoundingClientRect().top

            window.scrollTo({
                top: position,
                behavior: 'smooth'
            })
        }
        toDelivery()


        return {
            img_common_path,
            Home_Top_Img,
            header_title,
            header_title_sp,
            digital_banner,
            toDelivery
        }
    }

}
</script>